import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import './styles.css'
import logo from './logo.png'
import { NavLink } from 'react-router-dom'
import { setTenant } from '../../actions/system'
import {JETMS} from "@jet/jetms-client-sdk/dist/window"
import TenantSelector from './tenantSelector'
import PropTypes from 'prop-types'


class Header extends React.Component {
  componentDidMount() {
    // Tenant is resolved from URL by index.js, but validate defensively at point of use
    const pathSegments = window.location.pathname.split('/').filter(Boolean)
    const firstSegment = pathSegments[0] ? pathSegments[0].toLowerCase() : null
    const tenants = window.env.tenants || []
    const tenant = firstSegment && tenants.indexOf(firstSegment) !== -1
      ? firstSegment
      : tenants[0]
    this.props.setTenant(tenant)
  }
  render() {
    return <header>
      <nav className="navbar navbar-expand-lg">
        <img alt="Delivery Management" src={logo} height="30px" /> <h3>Delivery Management</h3>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <ul className="navbar-nav mr-auto">         
        </ul>
        <div>
          {typeof JETMS === "undefined" && <TenantSelector tenant={'uk'} />}
        </div>
      </nav>
      <div className="nav-scroller bg-white box-shadow">
        <nav className="nav nav-underline">
          <NavLink className="nav-link" activeClassName={'active'} to={'/pools'}> <h4> Pools </h4></NavLink>
          <NavLink className="nav-link" activeClassName={'active'} to={'/restaurants'}><h4>Restaurants </h4></NavLink>
        </nav>
      </div>
    </header>
  }

}

Header.propTypes = {
  setTenant: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => {
   return {
    ...props,
    router: state.router
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  setTenant
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)



// WEBPACK FOOTER //
// ./src/components/header/index.js